<template>
  <div class="admin col-12">
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header"> Pot Setup </div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="temp in pot_setups">
            <div
              class="row clickable"
              :key="temp.id"
              v-show="temp.active == !show_deleted"
              v-bind:class="{ selected: temp == item }"
              @click="_itemSelected(temp)"
            >
              <div class="col-12">
                {{ temp.description }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-9">
        <div class="row">
          <PotSetupDetail
            :selectedItem="item"
            class="col-12"
            v-show="showPotSetup"
            ref="pot_size"
            @new="_new_item"
          />
        </div>
      </div>
    </div>

    <CreatePotSetup
      ref="pot_setup_modal"
      v-show="showCreatePotSetup"
      @close="_closeNewModal"
    />

    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted">Show Deleted</label>
      </div>
    </div>
  </div>
</template>

<script>
import PotSetupDetail from "@/components/admin/inventory/detail/PotSetupDetail.vue";
import CreatePotSetup from "@/components/admin/inventory/create/CreatePotSetup.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "ManagePotSetup",

  // DATA
  data: () => ({
    item: null,
    loading: false,
    show_deleted: false,
    showCreatePotSetup: false,
    showPotSetup: true,
  }),

  // COMPUTED
  computed: {
    ...mapState("inventory", ["pot_setups", "new_pot_setup"]),
  },

  // MOUNTED
  mounted() {
    this.$nextTick(() => {
      this.getPotSetups();
    });
  },

  // WATCH
  watch: {
    new_plant_botany(new_value) {
      this.item = new_value;
      this.$refs.pot_setup_modal.clear();
    },
  },

  // METHODS
  methods: {
    ...mapActions("inventory", ["apiCreatePotSetup", "getPotSetups"]), // inventory.js

    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },

    _save() {
      this.$refs.pot_size.save();
    },

    _new_item() {
      this.showCreatePotSetup = true;
    },

    _closeNewModal() {
      this.showCreatePotSetup = false;
    },

    _showTab(index) {
      this.tab = index;
    },

    _itemSelected(item) {
      this.item = item;
      this.showPotSetup = true;
    },

    _delete_item() {
      if (this.item != null && this.item.id > 0) {
        this.item.active = !this.item.active;
        this.apiSavePotSetup(this.item);
      }
    },
  },

  // COMPONENTS
  components: {
    PotSetupDetail,
    CreatePotSetup,
  },
};
</script>
